// ============================================================
// Mock Schools
// ============================================================

export const mockSchools = [
  {
    id: 'school-1',
    organizationId: 'org-1',
    name: 'Green Valley School',
    code: 'GV-001',
    registrationNumber: 'REG-2023-001',
    affiliationNumber: 'AFF-CBSE-1001',
    schoolType: 'Co-Ed / CBSE',
    establishedYear: 1995,
    logo: null,
    address: '123 Green Valley Road',
    city: 'Delhi',
    state: 'Delhi',
    country: 'India',
    pinCode: '110001',
    phone: '+91 11 2222 3333',
    alternatePhone: '+1 (555) 111-3333',
    email: 'contact@greenvalley.com',
    website: 'www.greenvalley.edu',
    principalName: 'Dr. Sarah Johnson',
    vicePrincipal: 'Mr. John Doe',
    officeContact: '+1 (555) 111-4444',
    officeEmail: 'office@greenvalley.com',
    academicSession: '2023-2024',
    totalClasses: 12,
    totalSections: 48,
    studentCount: 320,
    boys: 170,
    girls: 150,
    teachers: 85,
    staff: 40,
    status: 'active',
    lastUpdated: '2026-07-15T10:00:00Z'
  },
  {
    id: 'school-2',
    organizationId: 'org-1',
    name: 'Green Valley School',
    code: 'GV-002',
    registrationNumber: 'REG-2010-045',
    affiliationNumber: 'AFF-CBSE-2045',
    schoolType: 'Co-Ed / CBSE',
    establishedYear: 2010,
    logo: null,
    address: '45 Education Lane',
    city: 'Lucknow',
    state: 'Uttar Pradesh',
    country: 'India',
    pinCode: '226001',
    phone: '+91 98765 43210',
    alternatePhone: '+91 98765 43211',
    email: 'contact@dpslucknow.com',
    website: 'www.dpslucknow.com',
    principalName: 'Mr. Rajesh Kumar',
    vicePrincipal: 'Ms. Anita Sharma',
    officeContact: '+91 98765 43212',
    officeEmail: 'admin@dpslucknow.com',
    academicSession: '2023-2024',
    totalClasses: 14,
    totalSections: 56,
    studentCount: 415,
    boys: 215,
    girls: 200,
    teachers: 120,
    staff: 65,
    status: 'active',
    lastUpdated: '2026-07-16T14:30:00Z'
  },
  {
    id: 'school-3',
    organizationId: 'org-2',
    name: 'Green Valley School',
    code: 'GV-003',
    registrationNumber: 'REG-2005-112',
    affiliationNumber: 'AFF-ICSE-3012',
    schoolType: 'Co-Ed / ICSE',
    establishedYear: 2005,
    logo: null,
    address: '78 Oxford Street, City Center',
    city: 'Pune',
    state: 'Maharashtra',
    country: 'India',
    pinCode: '411001',
    phone: '+91 20 7123 4567',
    alternatePhone: '+91 20 7123 4568',
    email: 'info@oxfordpublic.edu',
    website: 'www.oxfordpublic.edu',
    principalName: 'Ms. Emily Chen',
    vicePrincipal: 'Mr. David Smith',
    officeContact: '+44 20 7123 4569',
    officeEmail: 'admin@oxfordpublic.edu',
    academicSession: '2023-2024',
    totalClasses: 10,
    totalSections: 30,
    studentCount: 280,
    boys: 140,
    girls: 140,
    teachers: 60,
    staff: 25,
    status: 'inactive',
    lastUpdated: '2026-07-10T09:15:00Z'
  },
  {
    id: 'school-4',
    organizationId: 'org-2',
    name: 'Green Valley School',
    code: 'GV-004',
    registrationNumber: 'REG-2015-089',
    affiliationNumber: 'AFF-IGCSE-9921',
    schoolType: 'Co-Ed / IGCSE',
    establishedYear: 2015,
    logo: null,
    address: '99 Sunrise Boulevard',
    city: 'Bangalore',
    state: 'Karnataka',
    country: 'India',
    pinCode: '560001',
    phone: '+91 80 1234 5678',
    alternatePhone: '+91 80 1234 5679',
    email: 'contact@sunriseacademy.ae',
    website: 'www.sunriseacademy.ae',
    principalName: 'Dr. Ahmed Al-Maktoum',
    vicePrincipal: 'Mrs. Fatima Zahra',
    officeContact: '+971 4 123 4569',
    officeEmail: 'admin@sunriseacademy.ae',
    academicSession: '2023-2024',
    totalClasses: 13,
    totalSections: 40,
    studentCount: 512,
    boys: 262,
    girls: 250,
    teachers: 110,
    staff: 50,
    status: 'active',
    lastUpdated: '2026-07-17T11:20:00Z'
  },
  {
    id: 'school-5',
    organizationId: 'org-3',
    name: 'Green Valley School',
    code: 'GV-005',
    registrationNumber: 'REG-1980-002',
    affiliationNumber: 'AFF-STATE-102',
    schoolType: 'Girls / State Board',
    establishedYear: 1980,
    logo: null,
    address: '15 Heritage Road',
    city: 'Mumbai',
    state: 'Maharashtra',
    country: 'India',
    pinCode: '400001',
    phone: '+91 22 2345 6789',
    alternatePhone: '+91 22 2345 6790',
    email: 'principal@stmarys.edu.in',
    website: 'www.stmarys.edu.in',
    principalName: 'Sister Margaret',
    vicePrincipal: 'Sister Agnes',
    officeContact: '+91 22 2345 6791',
    officeEmail: 'office@stmarys.edu.in',
    academicSession: '2023-2024',
    totalClasses: 10,
    totalSections: 20,
    studentCount: 350,
    boys: 0,
    girls: 350,
    teachers: 45,
    staff: 20,
    status: 'active',
    lastUpdated: '2026-07-16T08:00:00Z'
  }
];

export const mockSchoolSummaries = {
  'school-1': {
    todaysCollection: 45000,
    thisMonthCollection: 1250000,
    pendingFees: 350000,
    collectionPercentage: 85,
    outstandingBalance: 350000,
    todaysPresent: 1180,
    todaysAbsent: 70,
    attendancePercentage: 94.4,
    newAdmissions: 45,
    transfers: 12,
    inactiveStudents: 5,
    averageAttendance: 95.2,
    monthlyAttendanceTrend: [92, 94, 95, 93, 96, 95, 94]
  },
  'school-2': {
    todaysCollection: 85000,
    thisMonthCollection: 2800000,
    pendingFees: 800000,
    collectionPercentage: 78,
    outstandingBalance: 800000,
    todaysPresent: 1950,
    todaysAbsent: 150,
    attendancePercentage: 92.8,
    newAdmissions: 120,
    transfers: 35,
    inactiveStudents: 15,
    averageAttendance: 91.5,
    monthlyAttendanceTrend: [90, 91, 89, 92, 93, 91, 92]
  },
  'school-3': {
    todaysCollection: 0,
    thisMonthCollection: 450000,
    pendingFees: 120000,
    collectionPercentage: 90,
    outstandingBalance: 120000,
    todaysPresent: 800,
    todaysAbsent: 50,
    attendancePercentage: 94.1,
    newAdmissions: 15,
    transfers: 5,
    inactiveStudents: 2,
    averageAttendance: 96.0,
    monthlyAttendanceTrend: [95, 96, 95, 97, 96, 95, 94]
  },
  'school-4': {
    todaysCollection: 125000,
    thisMonthCollection: 4500000,
    pendingFees: 1100000,
    collectionPercentage: 81,
    outstandingBalance: 1100000,
    todaysPresent: 1420,
    todaysAbsent: 80,
    attendancePercentage: 94.6,
    newAdmissions: 85,
    transfers: 22,
    inactiveStudents: 10,
    averageAttendance: 93.5,
    monthlyAttendanceTrend: [92, 93, 94, 93, 95, 94, 96]
  },
  'school-5': {
    todaysCollection: 12000,
    thisMonthCollection: 850000,
    pendingFees: 50000,
    collectionPercentage: 95,
    outstandingBalance: 50000,
    todaysPresent: 880,
    todaysAbsent: 20,
    attendancePercentage: 97.7,
    newAdmissions: 10,
    transfers: 2,
    inactiveStudents: 1,
    averageAttendance: 98.0,
    monthlyAttendanceTrend: [97, 98, 97, 99, 98, 97, 98]
  }
};
